import React, { Fragment } from "react"
import { MdClose } from "react-icons/md"
import { useTranslation } from "react-i18next"

import {
  deliveryTypeLabels,
  orderStatusLabels,
  productUnitsSymbol
} from "constant"
import { formatMobilePhone, moment, scale } from "utils"
import PlSeparator from "./PlSeparator"
import PlSpecificationItems from "./PlSpecificationItems"

const PlOrderPrintTemplateForKitchen = (props) => {
  const {
    forPos,
    templateType,
    printData,
    printerWidth,
    thisPrinterOrderItems
  } = props

  const {
    date,
    code,
    note,
    queueNumber,
    tableNumber,
    kitchenTitle,
    customerFullName,
    customerMobilePhone,
    serviceTypeName,
    orderStatus,
    deliveryType,
    cinemaSolonNumber
  } = printData

  const [t] = useTranslation()

  const showTableNumber =
    !!tableNumber &&
    serviceTypeName === "restaurant"

  const styles =
    templateType === "thermal" ? stylesThermal(printerWidth) : stylesOthers

  return (
    <div style={styles["container"]}>
      <div style={styles["title"]}>
        ({t("پرینت_لیست_کالا")})
      </div>

      <div style={styles["headerTable"]}>
        <div style={styles["row"]}>
          <div style={styles["cell1"]}>
            <div style={{ ...styles["text"], ...styles["center"] }}>
              {moment(date).format("HH:mm")}
            </div>
            <div style={{ ...styles["text"], ...styles["center"] }}>
              {moment(date).format("jYYYY/jMM/jDD")}
            </div>
          </div>
          <div style={styles["cell2"]}>
            <div style={{ ...styles["text"], ...styles["center"] }}>
              {kitchenTitle}
            </div>
            <div style={{ ...styles["text1"], ...styles["center"] }}>
              {customerFullName}
              <br />
              {formatMobilePhone(customerMobilePhone)}
            </div>
          </div>
          <div style={styles["cell1"]}>
            <div style={{ ...styles["text"], ...styles["center"] }}>
              {t("فاکتور")}
            </div>
            <div style={{ ...styles["text1"], ...styles["center"] }}>
              {code}
            </div>
          </div>
        </div>

        <div style={styles["row"]}>
          <div style={styles["cell3"]}>
            <div style={{ ...styles["text"], ...styles["center"] }}>
              {t("روش_پرداخت")}:{" "}
              <span style={styles["bold"]}>
                {t("صندوقدار")}
              </span>
            </div>
            <div style={{ ...styles["text1"], ...styles["center"] }}>
              {t("وضعیت_پرداخت")}:{" "}
              <span style={styles["bold"]}>
                {t(orderStatusLabels[orderStatus])}
              </span>
            </div>
            <div style={{ ...styles["text1"], ...styles["center"] }}>
              {t("نحوه_تحویل")}:{" "}
              <span style={styles["bold"]}>
                {t(deliveryTypeLabels[deliveryType])}
                {deliveryType === "cinema" ? ` (${cinemaSolonNumber})` : ""}
              </span>
            </div>
            {
              showTableNumber &&
              <div style={styles["text1"]}>
                {t("میز")}:
                <span>{String(tableNumber)}</span>
              </div>
            }
          </div>
          <div style={styles["cell1"]}>
            <div style={{ ...styles["text"], ...styles["center"] }}>
              {t("شماره")}
            </div>
            <div style={{ ...styles["text1"], ...styles["center"] }}>
              {queueNumber}
            </div>
          </div>
        </div>
      </div>

      <div style={styles["text2"]}>
        {t("توضیحات")}:
      </div>

      <div style={styles["tableContainer"]}>
        <div style={styles["table"]}>
          <div style={styles["row"]}>
            <div style={styles["th_name"]}>
              <div style={styles["thText"]}>
                {t("نام_کالا")}
              </div>
            </div>
            <div style={styles["th_qty"]}>
              <div style={styles["thText"]}>
                {t("واحد")}
              </div>
            </div>
          </div>

          {thisPrinterOrderItems.map((item, itemIndex) =>
            <div key={itemIndex} style={styles["row"]}>
              <div style={styles["td_name"]}>
                <div style={styles["tdText"]}>
                  {item.foodName}
                </div>
                {
                  !item.isSimple &&
                  <div style={styles["optionName"]}>
                    {item.optionName}
                  </div>
                }
                <PlSpecificationItems items={item.specificationItems}>
                  {(specificationItem, siIndex) =>
                    <div
                      key={siIndex}
                      style={styles["optionName"]}
                    >
                      {specificationItem.name}
                      {
                        !specificationItem.isSelectable &&
                        <Fragment>
                          <MdClose />
                          {specificationItem.quantity * item.quantity}
                        </Fragment>
                      }
                    </div>
                  }
                </PlSpecificationItems>
              </div>
              <div style={styles["td_qty"]}>
                <div style={styles["tdText"]}>
                  {item.quantity} {productUnitsSymbol[item.unit]}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      {
        note &&
        <Fragment>
          <div style={styles["text2"]}>
            {t("یادداشت")}:
          </div>
          <div style={styles["note"]}>
            {note}
          </div>
        </Fragment>
      }

      <PlSeparator
        forPos={forPos}
        templateType={templateType}
      />
    </div>
  )
}

const stylesThermal = (printerWidth) => ({
  container: {
    fontSize: scale("19px", printerWidth),
  },

  headerTable: {
    border: `${scale("1px")} solid`,
  },

  row: {
    display: "flex",
    flexDirection: "row"
  },

  text: {

  },

  center: {
    textAlign: "center"
  },

  cell1: {
    flex: 1,
    border: `${scale("1px")} solid`,
    display: "flex",
    flexDirection: "column"
  },

  cell2: {
    flex: 2,
    border: `${scale("1px")} solid`,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center"
  },

  cell3: {
    flex: 3,
    border: `${scale("1px")} solid`,
  },

  text1: {

    borderTop: `${scale("1px")} solid`,
    width: "100%"
  },

  title: {

    textAlign: "center",
    marginBottom: scale("8px")
  },

  text2: {

    marginTop: scale("4px"),
    marginBottom: scale("4px")
  },

  text4: {

    textAlign: "center",
    borderBottom: `${scale("1px")} solid`
  },

  text5: {
    flex: 1,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderBottom: `${scale("1px")} solid`
  },

  tableContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center"
  },

  table: {
    width: "100%",
    border: `${scale("1px")} solid`,
    marginTop: "0px"
  },

  th_name: {
    flex: 1.5,
    padding: scale("1px"),
    color: "black"
  },

  th_qty: {
    flex: 0.4,
    padding: scale("1px"),
    color: "black"
  },

  th_price: {
    flex: 1,
    padding: scale("1px"),
    color: "black"
  },

  td_name: {
    flex: 1.5,
    padding: scale("1px"),
    border: `${scale("1px")} solid`,
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start"
  },

  td_qty: {
    flex: 0.4,
    padding: scale("1px"),
    border: `${scale("1px")} solid`,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center"
  },

  thText: {
    fontWeight: "bold",
    textAlign: "center",

  },

  tdText: {

  },

  optionName: {
    display: "flex",
    alignItems: "center"
  },

  specificationItem: {

  },

  note: {
    fontWeight: "bold",
  },


  bold: {
    fontWeight: "bold"
  }
})

const stylesOthers = {
  container: {
    marginRight: "8px",
    fontSize: "11px"
  },

  headerTable: {
    border: "1px solid",
  },

  row: {
    display: "flex",
    flexDirection: "row"
  },

  center: {
    textAlign: "center"
  },

  cell1: {
    flex: 1,
    border: "1px solid",
    display: "flex",
    flexDirection: "column"
  },

  cell2: {
    flex: 2,
    border: "1px solid",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center"
  },

  cell3: {
    flex: 3,
    border: "1px solid"
  },

  text1: {
    borderTop: "1px solid",
    width: "100%"
  },
  title: {
    fontWeight: "bold",
    textAlign: "center",
    marginBottom: "10px"
  },

  text2: {
    marginTop: "10px",
    marginBottom: "10px"
  },

  text4: {
    textAlign: "center",
    borderBottom: "1px solid"
  },

  text5: {
    flex: 1,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderBottom: "1px solid"
  },

  tableContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center"
  },

  table: {
    width: "100%",
    border: "1px solid",
    marginTop: "0px"
  },

  th_name: {
    flex: 1.406,
    padding: "1px",
    color: "black"
  },

  th_qty: {
    flex: 0.4,
    padding: "1px",
    color: "black"
  },

  th_price: {
    flex: 1,
    padding: "1px",
    color: "black"
  },

  td_name: {
    flex: 1.406,
    padding: "1px",
    border: "1px solid",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start"
  },

  td_qty: {
    flex: 0.4,
    padding: "1px",
    border: "1px solid",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },

  thText: {
    fontWeight: "bold",
    textAlign: "center"
  },

  note: {
    fontWeight: "bold"
  },

  bold: {
    fontWeight: "bold"
  },

  optionName: {
    display: "flex",
    alignItems: "center"
  },
}

export default PlOrderPrintTemplateForKitchen
